import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  class: "gfu-project-summary-funded-info",
  "data-qa": "project-summary-box:FundedBanner"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "gfu-project-summary-action"
}
const _hoisted_4 = {
  key: 2,
  class: "gfu-project-summary-action"
}
const _hoisted_5 = { class: "_tac _pt-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_summary_progress = _resolveComponent("project-summary-progress")
  const _component_project_promo_item = _resolveComponent("project-promo-item")
  const _component_project_summary_clock = _resolveComponent("project-summary-clock")
  const _component_project_summary_stretch_goal = _resolveComponent("project-summary-stretch-goal")
  const _component_project_summary_stretch_goal_completed = _resolveComponent("project-summary-stretch-goal-completed")
  const _component_back_project_button = _resolveComponent("back-project-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_project_summary_backer = _resolveComponent("project-summary-backer")
  const _component_project_summary_follow = _resolveComponent("project-summary-follow")
  const _component_project_summary_box = _resolveComponent("project-summary-box")
  const _component_project_summary_overtime = _resolveComponent("project-summary-overtime")
  const _component_project_summary_details = _resolveComponent("project-summary-details")
  const _component_project_summary_card = _resolveComponent("project-summary-card")

  return (_openBlock(), _createBlock(_component_project_summary_card, { "is-flipped": $data.showDetails }, {
    front: _withCtx(() => [
      (!_ctx.isCrowdfundingOvertimeActive)
        ? (_openBlock(), _createBlock(_component_project_summary_box, {
            key: 0,
            borderless: true,
            "data-qa": "project-summary-box:Active"
          }, _createSlots({
            actions: _withCtx(() => [
              ($options.isBackAgainButtonVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_tooltip, {
                      text: _ctx.Resources.ProjectHome.CrowdfundingExpressUpgradeLimitationText,
                      enabled: !$options.canMakeAnotherPledge
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_back_project_button, {
                          disabled: !$options.canMakeAnotherPledge
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.CrowdfundingBackAgainButton), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["text", "enabled"])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isBacker)
                ? (_openBlock(), _createBlock(_component_project_summary_backer, {
                    key: 1,
                    number: $props.backerNumber,
                    href: $options.effectiveBackProjectUrl
                  }, null, 8 /* PROPS */, ["number", "href"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_back_project_button)
                  ])),
              ($options.showFollowButton)
                ? (_openBlock(), _createBlock(_component_project_summary_follow, {
                    key: 3,
                    "show-button-follower-count": false
                  }))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("a", {
                  href: "#",
                  class: "gfu-link gfu-link--accent",
                  onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.toggleShowDetails && $options.toggleShowDetails(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryLearnMoreButton), 1 /* TEXT */)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_project_summary_progress, _mergeProps($options.progressModel, { class: "gfu-project-summary-box__progress" }), null, 16 /* FULL_PROPS */),
              (_ctx.promoItem)
                ? (_openBlock(), _createBlock(_component_project_promo_item, {
                    key: 0,
                    class: "gfu-project-summary-promo-item",
                    "data-qa": `project-summary-promo-item:${_ctx.promoItem.type}`
                  }, null, 8 /* PROPS */, ["data-qa"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    ($options.campaignEndInThreeDays)
                      ? (_openBlock(), _createBlock(_component_project_summary_clock, {
                          key: 0,
                          "elapsed-message": _ctx.Resources.ProjectHome.ProjectSummaryClockElapsedMessage,
                          "target-date": $options.campaignOriginalEndDate,
                          title: _ctx.Resources.ProjectHome.ProjectSummaryClockElapsedTitle,
                          class: "_mt-3"
                        }, null, 8 /* PROPS */, ["elapsed-message", "target-date", "title"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          ($options.nextStretchGoal)
                            ? (_openBlock(), _createBlock(_component_project_summary_stretch_goal, _mergeProps({ key: 0 }, $options.nextStretchGoal, { class: "_my-3" }), null, 16 /* FULL_PROPS */))
                            : _createCommentVNode("v-if", true),
                          ($options.allStretchGoalCompleted)
                            ? (_openBlock(), _createBlock(_component_project_summary_stretch_goal_completed, {
                                key: 1,
                                "stretch-goals-url": $props.stretchGoalsUrl,
                                class: "_my-3"
                              }, null, 8 /* PROPS */, ["stretch-goals-url"]))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                  ], 64 /* STABLE_FRAGMENT */))
            ]),
            _: 2 /* DYNAMIC */
          }, [
            ($options.isFundedInfoVisible)
              ? {
                  name: "sticky",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("span", { innerHTML: $options.goalReachedInText }, null, 8 /* PROPS */, _hoisted_2)
                    ])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1024 /* DYNAMIC_SLOTS */))
        : (_openBlock(), _createBlock(_component_project_summary_overtime, {
            key: 1,
            class: "gfu-animation-glow--urgent-lighter",
            backers: $options.campaignOvertimeBackers,
            onToggleShowDetails: $options.toggleShowDetails
          }, null, 8 /* PROPS */, ["backers", "onToggleShowDetails"]))
    ]),
    back: _withCtx(() => [
      ($data.showDetails)
        ? (_openBlock(), _createBlock(_component_project_summary_details, _mergeProps({ key: 0 }, $options.detailsModel, { onClose: $options.toggleShowDetails }), null, 16 /* FULL_PROPS */, ["onClose"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-flipped"]))
}